export interface ComparisonFeature {
    name: string
    Go: boolean | string
    Grow: boolean | string
    Glory: boolean | string
    tooltip?: string
}

export interface ComparisonCategory {
    name: string
    icon: string
    features: ComparisonFeature[]
}

export type PlanType = "Go" | "Grow" | "Glory"

export const PRICING_COMPARISON: ComparisonCategory[] = [
    {
        name: "Growth & Engagement",
        icon: "/img/pricing/ic_growth.png",
        features: [
            {
                name: "Monthly Followers",
                Go: "<b>1,000-2,000</b>",
                Grow: "<b>2,500-3,500</b>",
                Glory: "<b>4,000+ guaranteed</b>",
                tooltip: "Estimated new monthly followers with full refund if no net-positive growth after 30 days"
            },
            {
                name: "Real Engagement",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Real active engagement from real people, no bots"
            },
            {
                name: "24/7 Live Growth",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Continuous growth automation even while you sleep"
            },
            {
                name: '<span class="outfame-max-gradient">Outfame MAX™</span>',
                Go: false,
                Grow: true,
                Glory: true,
                tooltip: "AI-powered growth acceleration with 2.75x more followers per month"
            }
        ]
    },
    {
        name: "AI & Targeting",
        icon: "/img/pricing/ic_ai.png",
        features: [
            {
                name: "AI-Optimization",
                Go: false,
                Grow: true,
                Glory: true,
                tooltip: "AI data models for profile optimization"
            },
            {
                name: "Smart Auto Targeting",
                Go: false,
                Grow: true,
                Glory: true,
                tooltip: "Advanced AI audience targeting"
            },
            {
                name: "Location Filter",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Target by geographic location"
            },
            {
                name: "Age & Gender Filters",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Filter followers by demographics"
            },
            {
                name: "Language Targeting",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Reach followers in their language"
            },
            {
                name: "AI Image Posts",
                Go: false,
                Grow: "15/mo",
                Glory: "30/mo",
                tooltip: "AI-generated content posts per month"
            }
        ]
    },
    {
        name: "Analytics & Support",
        icon: "/img/pricing/ic_analytics.png",
        features: [
            {
                name: "Real-Time Analytics",
                Go: true,
                Grow: true,
                Glory: true,
                tooltip: "Live dashboard for growth and engagement metrics"
            },
            {
                name: '<span class="boost-post-gradient">Boost Post</span>',
                Go: false,
                Grow: false,
                Glory: true,
                tooltip: "Real engagement signals delivered in the critical first 30 minutes after posting to trigger the algorithm and maximize your reach. 3x higher reach on average."
            },
            {
                name: "Inspiration Library",
                Go: false,
                Grow: false,
                Glory: true,
                tooltip: "Viral content templates and ideas"
            },
            {
                name: "PDF Growth Reports",
                Go: false,
                Grow: false,
                Glory: true,
                tooltip: "Downloadable analytics reports"
            },
            {
                name: "Dedicated Account Manager",
                Go: false,
                Grow: false,
                Glory: true,
                tooltip: "Personal manager for your account"
            }
        ]
    }
]

export const PLAN_INFO = {
    Go: {
        name: "Go",
        monthlyPrice: 49,
        yearlyPrice: 29,
        ctaText: "Try for free",
        ctaLink: "/setup",
        featured: false,
        buttonBg: "#60a5fa",
        buttonColor: "#fff"
    },
    Grow: {
        name: "Grow",
        monthlyPrice: 69,
        yearlyPrice: 41,
        ctaText: "Try for free",
        ctaLink: "/setup",
        featured: true,
        buttonBg: "#ffa3d1",
        buttonColor: "#141414"
    },
    Glory: {
        name: "Glory",
        monthlyPrice: 129,
        yearlyPrice: 99,
        ctaText: "Try for free",
        ctaLink: "/setup",
        featured: false,
        buttonBg: "#c084fc",
        buttonColor: "#fff"
    }
}
